
import * as angular from "angular";
import { StateProvider } from "@uirouter/angularjs";

import { VehicleDataService } from "./vehicleData.service";
import { FleetMaintenanceController } from "./fleetMaintenance.controller";

export class Config {

    static PageStateName = "app.components_fleetMaintenance";

    constructor($stateProvider: StateProvider) {

        $stateProvider.state(Config.PageStateName, {
            url: "/components/fleetMaintenance",
            views: {
                "content@app": {
                    template: require("./fleetMaintenance.html"),
                    controller: "fleetMaintenanceController",
                    controllerAs: "$ctrl"
                }
            },
            params: {
                title: "FleetMaintenance",
                page: { squash: true, value: null, dynamic: true }
            }
        });
    }
}

angular
    .module("app.components.fleetMaintenance", [
        "ui.router",
        "ngMaterial"
    ])
    .config(["$stateProvider", Config])
    .service("vehicleDataService", VehicleDataService)
    .controller("fleetMaintenanceController", FleetMaintenanceController);
